import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import Keycloak from 'keycloak-js';
import { BrowserView, MobileView } from 'react-device-detect';
import { isAuthenticated } from '../../auth/keycloak';
import { getUserName } from '../../service/lobby';
import { UserProfile } from '../../service/social';
import { NotificationToggle } from '../gameComponents/NotificationToggle';
import { AvatarImage } from './AvatarImage';
import { ProfileActions } from './ProfileActions';
import { ProfileSocialLinks } from './ProfileSocialLinks';

interface PublicProfileInfoParams {
    userProfile: UserProfile;
    imageUrl: string;
    keycloak: Keycloak;
    isLive: boolean;
}

export const PublicProfileInfo: React.FC<PublicProfileInfoParams> = ({
    userProfile,
    imageUrl,
    keycloak,
    isLive,
}) => {
    const usernameText = getUserName(userProfile);

    return (
        <>
            <BrowserView className={'profile-info-browser'}>
                <Flex className={'profile-avatar-container'}>
                    <AvatarImage src={imageUrl} alt={`${usernameText}'s profile photo`} />
                </Flex>
                <Flex className="profile-details-browser">
                    <Flex className="profile-browser-row">
                        <Flex className={'profile-details-text'}>
                            <Heading className="username" size="lg">
                                {usernameText}
                            </Heading>
                            {userProfile.description && (
                                <Text className="blurb">{userProfile.description}</Text>
                            )}
                        </Flex>
                        <Flex>
                            {isAuthenticated(keycloak) &&
                                userProfile.id !== keycloak.tokenParsed?.sub && (
                                    <Box className="live-six-notification">
                                        <NotificationToggle
                                            streamSixIDText={userProfile.id}
                                            keycloak={keycloak}
                                        />
                                    </Box>
                                )}
                        </Flex>
                    </Flex>
                    <Flex className={'profile-live-links'}>
                        <Text>Watch Now!</Text>
                        <ProfileSocialLinks profile={userProfile} />
                    </Flex>
                </Flex>
                {isAuthenticated(keycloak) && userProfile.id !== keycloak.tokenParsed?.sub && (
                    <ProfileActions
                        userID={userProfile.id}
                        keycloak={keycloak}
                        userProfile={userProfile}
                    />
                )}
            </BrowserView>
            <MobileView className="profile-detail">
                <Flex className="profile-column-left">
                    <Flex className={'profile-avatar-container'}>
                        <AvatarImage src={imageUrl} alt={`${usernameText}'s profile photo`} />
                    </Flex>
                </Flex>
                <Flex className="profile-column-right">
                    <Flex className={'profile-info-row'}>
                        <Heading className="username" size="lg">
                            {usernameText}
                        </Heading>
                        {isAuthenticated(keycloak) &&
                            userProfile.id !== keycloak.tokenParsed?.sub && (
                                <Box className="live-six-notification">
                                    <NotificationToggle
                                        streamSixIDText={userProfile.id}
                                        keycloak={keycloak}
                                    />
                                </Box>
                            )}
                    </Flex>
                    {userProfile.description && (
                        <Text className="blurb">{userProfile.description}</Text>
                    )}
                </Flex>
            </MobileView>
        </>
    );
};
